import { useFormikContext } from 'formik';
import React from 'react';

import { TextButton } from '@components/Button/variants';
import EmailLeadCapture from '@components/EmailLeadCapture';
import useEventTracking from '@hooks/useEventTracking';
import { newsletter_list_path, subscribe_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { FormLocation, LeadTypes } from '@utils/enums';

interface NewsletterFormValues {
  [newsletterId: string]: boolean;
}

const OFFER_CODE = 'titv-pg-newsletter-module-299';
const SEE_ALL_NEWSLETTERS_TEXT = 'See all newsletters';

const SignupForm = () => {
  const { values } = useFormikContext<NewsletterFormValues>();
  const { trackEvent } = useEventTracking();

  return (
    <>
      <div className="mt-48 w-full">
        <EmailLeadCapture
          buttonText="Sign up"
          formClassName="w-full"
          formLocation={FormLocation.TITV}
          inputWrapperClassName="!w-full sm:!w-auto"
          inputClassName="w-full sm:w-[240px]"
          leadType={LeadTypes.TITVNewslettersSignup}
          newsletterIds={Object.keys(values)
            .filter((key) => values[key])
            .map((key) => parseInt(key))}
          redirectToOnSuccess={subscribe_path({ offer: OFFER_CODE })}
          toastMessageOnSuccess="Thank you for signing up for the newsletters."
        />
      </div>
      <TextButton
        as="link"
        href={newsletter_list_path()}
        className="mt-16 w-fit font-suisse-intl text-button-sm"
        onClickCapture={() =>
          trackEvent(
            click({
              clickTarget: ClickTarget.ViewAllNewsletters,
              clickText: SEE_ALL_NEWSLETTERS_TEXT,
            })
          )
        }
      >
        {SEE_ALL_NEWSLETTERS_TEXT}
      </TextButton>
    </>
  );
};

export default SignupForm;
